<template>
  <a-modal
      :visible="showRegisterModal"
      @cancel="_changeRegisterModal(false)"
      :footer="null"
      width="380px"
      :bodyStyle="bodyStyle"
  >
    <div class="login-modal">
      <div class="login-detail">
        <a-menu slot="title" style="text-align: center" v-model="current" mode="horizontal"
                @click="changeMenuItem ">
          <a-menu-item key="1"> 普通注册</a-menu-item>
        </a-menu>

        <a-form v-if="!isPhoneLogin" :form="form" @submit="handleSubmit">

          <a-form-item v-bind="formItemLayout" label="账户名">
            <a-input
                placeholder="请输入账户名(6-20位，非纯数字)!"
                v-decorator="[
                             'loginName',
                          {
                            rules: [
                              {
                                required: true,
                                message: '请输入账户名(6-20位，非纯数字)!',
                              },
                              {
                                validator: validateToNextPassword,
                              },
                            ],
                          },
                        ]"
                type="user"
            />
          </a-form-item>

          <a-form-item v-bind="formItemLayout" label="密码">
            <a-input
                placeholder="请输入你的密码(6-20位，非汉字)!"
                v-decorator="[
                                      'password',
                                      {
                                        rules: [
                                          {
                                            required: true,
                                            message: '请输入你的密码(6-20位，非汉字)!',
                                          },
                                          {
                                            validator: validateToNextPassword,
                                          },
                                        ],
                                      },
                                    ]"
                type="password"
            />
          </a-form-item>
          <a-form-item v-bind="formItemLayout" label="确认密码">
            <a-input
                placeholder="请再次输入你的密码!"
                v-decorator="[
          'confirm',
          {
            rules: [
              {
                required: true,
                message: '请确认您的密码！',
              },
              {
                validator: compareToFirstPassword,
              },
            ],
          },
        ]"
                type="password"
                @blur="handleConfirmBlur"
            />
          </a-form-item>
          <a-form-item v-bind="formItemLayout">
      <span slot="label">
        昵称&nbsp;
        <!--        <a-tooltip title="What do you want others to call you?">-->
        <!--          <a-icon type="question-circle-o" />-->
        <!--        </a-tooltip>-->
      </span>
            <a-input
                placeholder="请输入你的昵称!"
                v-decorator="[
          'nickname',
          {
            rules: [{ required: true, message: '请输入您的昵称！', whitespace: true }],
          },
        ]"
            />
          </a-form-item>

          <a-form-item v-bind="formItemLayout" label="手机号码">
            <a-input
                placeholder="请输入你的手机号!"
                v-decorator="[
          'phone',
          {
            rules: [{ required: true, message: '请输入您的电话号码！' }],
          },
        ]"
                style="width: 100%"
            >
              <a-select
                  slot="addonBefore"
                  v-decorator="['prefix', { initialValue: '86' }]"
                  style="width: 70px"
              >
                <a-select-option value="86">
                  +86
                </a-select-option>
              </a-select>
            </a-input>
          </a-form-item>
          <a-form-item
              v-bind="formItemLayout"
              label="验证码"
              extra=""
          >
            <a-row :gutter="8">
              <a-col :span="12">
                <a-input
                    placeholder="请输入验证码！!"
                    v-decorator="[
              'captcha',
              { rules: [{ required: true, message: '请输入你得到的验证码！' }] },
            ]"
                />
              </a-col>
              <a-col :span="12">
                <a-button @click="sendCode" style="width: 100%" :disabled=show type="primary">
                  {{ countText }}
                </a-button>
              </a-col>
            </a-row>
          </a-form-item>

          <a-form-item style="text-align: center">
            <a-button type="primary" style="width: 100%" :loading="loading" html-type="submit">
              注册
            </a-button>
            <div class="go-login" @click="_changeLoginModal(true)">去登录</div>
          </a-form-item>
        </a-form>

      </div>
    </div>

  </a-modal>
</template>

<script>
import common from "../../mixin/common";
import {createNamespacedHelpers} from "vuex";
import {registry, registerCode} from "@api/personal-api";
import {showMsg, showSuccessMsg, showWaringMsg} from "@utils/msg";

const {mapState} = createNamespacedHelpers('login');
export default {
  name: "LoginModel",
  mixins: [common],
  computed: {
    ...mapState(['showRegisterModal'])
  },
  data() {
    return {
      bodyStyle: {
        padding: '20px 36px 24px'
      },
      //默认选中
      current: ['1'],
      //    控制选择登录方式
      isPhoneLogin: false,

      //   控制框提交
      confirmDirty: false,
      // residences,
      autoCompleteResult: [],
      formItemLayout: {
        labelCol: {
          xs: {span: 24},
          sm: {span: 6},
        },
        wrapperCol: {
          xs: {span: 24},
          sm: {span: 18},
        },
      },
      //    验证码倒计时
      show: false,
      count: 0,
      countText: "获取验证码",

      //    点击注册显示加载中
      loading: false,
    };
  },

  beforeCreate() {
    this.form = this.$form.createForm(this, {name: 'normal_login'});
    this.form = this.$form.createForm(this, {name: 'register'});
  },
  methods: {
    changeMenuItem(item) {
      if (item.key == 1) {
        this.isPhoneLogin = false

      } else if (item.key == 2) {
        this.isPhoneLogin = true
      }
    },

    //自带验证函数
    handleSubmit(e) {
      e.preventDefault();
      this.loading = true
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          // var reg = /^\w{4,20}$/;
          let reg2 = /^\S{6,20}$/;
          //不许有中文
          let pattern = /^[^\u4e00-\u9fa5]{0,}$/
          // var emailChecking = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
          let phoneChecking = /^1[3456789]\d{9}$/
          //纯数字验证
          let reg = /^[0-9]+\s?[0-9]*$/

          if (!reg2.test(values.loginName) || !reg2.test(values.password)) {
            showWaringMsg('请正确输入6-20位的用户名和密码，禁止使用汉字和空格!');
            // alert("禁止特殊符号，请输入6-20位的用户名和密码");
            this.loading = false
            return;
          } else if (!pattern.test(values.loginName) || !pattern.test(values.password)) {
            showWaringMsg('请正确输入6-20位的用户名和密码，禁止使用汉字和空格!');
            this.loading = false
          } else if (reg.test(values.loginName)) {
            showWaringMsg('账户名不能为纯数字，请重新输入！');
            this.loading = false
            return false;
          } else if (values.nickname.length > 32) {
            showWaringMsg('昵称不能超过32位，请重新输入！');
            this.loading = false
            return false;
          } else if (!phoneChecking.test(values.phone)) {
            showWaringMsg('手机号格式不正确，请重新输入！');
            this.loading = false
            return false;
          } else {
            registry(values.loginName, values.password, values.nickname, values.phone, values.captcha, this.$route.query.memberRegistrationLinkCode || '').then(res => {
              if (res.code === 500) {
                showMsg(res.msg);
                this.loading = false
              } else if (res.code === 0) {
                showSuccessMsg("恭喜你，注册成功！");
                this.loading = false
                this._changeLoginModal(true)
              } else {
                this.loading = false

              }
            })
          }

        } else {
          this.loading = false
        }
      });
    },
    handleConfirmBlur(e) {
      const value = e.target.value;
      this.confirmDirty = this.confirmDirty || !!value;
    },
    compareToFirstPassword(rule, value, callback) {
      const form = this.form;
      if (value && value !== form.getFieldValue('password')) {
        callback('您输入的两个密码不一致！');
      } else {
        callback();
      }
    },
    validateToNextPassword(rule, value, callback) {
      const form = this.form;
      if (value && this.confirmDirty) {
        form.validateFields(['confirm'], {force: true});
      }
      callback();
    },
    handleWebsiteChange(value) {
      let autoCompleteResult;
      if (!value) {
        autoCompleteResult = [];
      } else {
        autoCompleteResult = ['.com', '.org', '.net'].map(domain => `${value}${domain}`);
      }
      this.autoCompleteResult = autoCompleteResult;
    },

    // /获取验证码
    sendCode() {
      this.show = true;
      this.form.validateFields((err, values) => {
        let phoneChecking = /^1[3456789]\d{9}$/
        if (!phoneChecking.test(values.phone)) {
          showWaringMsg('手机号格式不正确，请重新输入！');
          this.show = false;
          return false;
        } else {
          registerCode(values.phone).then((res) => {
            if (res.code == 0) {
              showSuccessMsg('发送成功，注意查收并正确填写验证码');
              //    60秒倒计时
              const TIME_COUNT = 60;
              if (!this.timer) {
                this.count = TIME_COUNT;
                // this.show = false;
                this.timer = setInterval(() => {
                  if (this.count > 0 && this.count <= TIME_COUNT) {
                    this.show = true;
                    this.count--;
                    this.countText = this.count + "s后重试"
                  } else {
                    this.show = false;
                    clearInterval(this.timer);
                    this.timer = null;
                    this.countText = "获取验证码"
                  }
                }, 1000)
              }
            } else if (res.code === 500) {
              this.show = false;
              clearInterval(this.timer);
              this.timer = null;
              this.countText = "获取验证码"
            } else {
              this.show = false;
              clearInterval(this.timer);
              this.timer = null;
              this.countText = "获取验证码"
            }

          })

        }
      });
    },
  },

}
</script>

<style scoped lang="less">
.login-detail {
  /*height: 600px;*/

  .ant-menu-item {
    width: 50%;
    text-align: center;
    margin-bottom: 10px;
  }

  .ant-menu-horizontal {
    border: none;
  }
}


.ant-form-item {
  margin-bottom: 14px;
}

.go-login {
  text-align: right;
  font-size: 13px;
  line-height: 16px;
  color: rgba(0, 0, 0, 0.65);
  cursor: pointer;
}

.go-login:hover {
  color: #00CF8C;
}
</style>
